import React, {useEffect} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import Icon from "../Icon";
import MatchTable from "../MatchTable";
import {setKey} from "../../util/util";
import {Space} from "antd"

export default () => {

    const {t} = useTranslation()

    useEffect(() => {

    }, [])

    return (<>

        <Space direction={'vertical'}>
            <Space>
                <Icon type={'ico'} size={30} name={'59'} />
                <h2 style={{color: '#52c41a'}}>{t('playing')}</h2>
                <Icon type={'ico'} size={30} name={'59'} />
            </Space>
            <MatchTable noPage style={{ width: '900px', }} columns={['region', 'mode', 'duration', 'team1', 'team2', 'score']} update={(pageInfo, setData) => {
                axios.get(`game/list2`).then(data => {
                    setKey(data, 'id')
                    setData(data)
                })
            }}/>
            <Space style={{marginTop: '50px'}}>
                <Icon type={'ico'} size={30} name={'53'} />
                <h2 style={{color: '#ffec3d'}}>{t('history')}</h2>
                <Icon type={'ico'} size={30} name={'53'} />
            </Space>
            <MatchTable style={{  width: '900px', }} columns={['region', 'mode', 'duration', 'team1', 'team2', 'score', 'endTime']} update={(pageInfo, setData) => {
                axios.get(`game/list`,{
                    params: {
                        current: pageInfo.current,
                        pageSize: 12,
                    }
                }).then(data => {
                    setKey(data.records, 'id')
                    pageInfo.total = data.total
                    pageInfo.pageSize = 12
                    setData(data.records)
                })
            }}/>
        </Space>

    </>)
}
